const isOdd = (x: number) => x % 2 !== 0;

interface Args {
  index: number;
  numberOfDots: number;
  maxDotsToShow: number;
}

export function getDotsToShow({
  index: i,
  numberOfDots: n,
  maxDotsToShow: m
}: Args): [firstDot: number, lastDot: number] {
  if (n <= m) {
    return [0, n - 1];
  }
  const l = Math.ceil(m / 2);
  const x0 = i - (l - 1);
  const x = isOdd(m) ? i + l - 1 : i + l;

  if (x0 < 0) {
    return [0, m - 1];
  }

  if (x > n - 1) {
    return [n - m, n - 1];
  }

  return [x0, x];
}
